import React, { ReactNode } from 'react';
import './contact-center.scss';

type Props = {
    config: {
        phone: string;
    };
    src?: string;
    icon: ReactNode;
    style?: {
        fontSize?: number;
    };
};

const ContactCenter = ({ config, src, icon, style }: Props) => (
    <div
        className="contact-center"
        style={style}
    >
        {src && (
            <img
                className="me-2"
                src={src}
            />
        )}
        {icon}
        {config.phone}
    </div>
);

export default ContactCenter;
